import { RefObject, useEffect } from 'react';
import { useDisableTaskOutlineQuery } from 'shared/hooks/queries/use-disable-task-outline-query';
import { Environments, isEnvironment } from 'shared/utils/is-environment';

const OUTLINE_RESET_DELAY = 200;

// Called below a React.memo boundary, a flash means the component ACTUALLY re-rendered —
// the deliberately-cheap wrapper layers above the memo re-run without flashing.
const useDevRenderOutlineImpl = (
  ref: RefObject<HTMLElement | null>,
  skip = false,
) => {
  const { data: isOutlineDisabled } = useDisableTaskOutlineQuery();

  useEffect(() => {
    if (isOutlineDisabled || skip || !ref.current) {
      return;
    }

    const element = ref.current;
    const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
    element.style.outline = `2px solid ${randomColor}`;
    element.style.transition = 'none';

    setTimeout(() => {
      element.style.outline = 'none';
      element.style.transition = 'outline 0.5s ease-out';
    }, OUTLINE_RESET_DELAY);
  });
};

const useNoopRenderOutline = (
  _ref: RefObject<HTMLElement | null>,
  _skip = false,
) => {};

export const useDevRenderOutline =
  isEnvironment(Environments.Development) || isEnvironment(Environments.Local)
    ? useDevRenderOutlineImpl
    : useNoopRenderOutline;
